export const widgetConstants = {
    WID_DEVICE_GROUP: "WID_DEVICE_GROUP",
    WID_PC_LIST: "WID_PC_LIST",
    WID_POWER: "WID_POWER",
    WID_SCENE_DALI: "WID_SCENE_DALI",
    WID_SCENE_DALI_ES_SYSTEM_DALI: "WID_SCENE_DALI_ES_SYSTEM_DALI",
    WID_VOLUME: "WID_VOLUME",
    WID_EXHIBITION_SCENARIO: "WID_EXHIBITION_SCENARIO",
    WID_VISIT: "WID_VISIT",
    WID_MZMAP: "WID_MZMAP",
    WID_SCENE_DMX: "WID_SCENE_DMX",
    WID_LANTICK: "WID_LANTICK",
    WID_SENSORS: "WID_SENSORS",
    WID_CUSTOM_BUTTONS: "WID_CUSTOM_BUTTONS"
};
